export default {
  tabs: {
    legalTender: "法币汇总",
    virtualCoin: "虚拟币汇总",
    transactionDetails: "交易详情",
  },
  download: {
    filename: "数据明细",
  },
};
